import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getConfigQuanto, saveConfigQuantoBatch } from '../../api/configQuanto';
import {
  NON_TRADING_DAY_FILL_METHODS,
  NON_TRADING_DAY_FILL_OPTIONS,
  type ConfigQuanto,
} from '../../types/ConfigQuanto';
import { t } from '../../i18n/t';

// Central, bank-wide list of indices for the quanto-coefficient calc (part of the
// variable management fee). Operator edits; Fund Manager views (read-only via the
// configQuanto resource permission — LopCrudPage gates editing on it).
const configQuantoColumnDefs: ColDef<ConfigQuanto>[] = [
  {
    field: 'recId',
    headerName: t('configQuanto.columns.recId'),
    width: 110,
    // IDENTITY PK — server-assigned, never edited.
    editable: false,
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'symbol',
    headerName: t('configQuanto.columns.symbol'),
    flex: 1,
    minWidth: 160,
    editable: true,
  },
  {
    field: 'isHardCoded',
    headerName: t('configQuanto.columns.isHardCoded'),
    width: 130,
    editable: true,
    cellDataType: 'boolean',
  },
  {
    field: 'secondSymbol',
    headerName: t('configQuanto.columns.secondSymbol'),
    flex: 1,
    minWidth: 160,
    editable: true,
  },
  {
    field: 'nonTradingDayFillMethod',
    headerName: t('configQuanto.columns.nonTradingDayFillMethod'),
    width: 230,
    editable: true,
    cellDataType: 'text',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: { values: [...NON_TRADING_DAY_FILL_METHODS] },
  },
  {
    field: 'nonTradingDayFillOption',
    headerName: t('configQuanto.columns.nonTradingDayFillOption'),
    width: 180,
    editable: true,
    cellDataType: 'text',
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: { values: [...NON_TRADING_DAY_FILL_OPTIONS] },
  },
];

const newConfigQuantoDefaults = (): Partial<ConfigQuanto> => ({
  recId: 0,
  symbol: '',
  isHardCoded: false,
  secondSymbol: null,
  nonTradingDayFillMethod: null,
  nonTradingDayFillOption: null,
});

export function ConfigQuantoPage() {
  return (
    <LopCrudPage<ConfigQuanto>
      resourceCode="configQuanto"
      titleKey="configQuanto.pageTitle"
      idField="recId"
      getRows={getConfigQuanto}
      saveBatch={(added, modified, deletedIds) =>
        saveConfigQuantoBatch(added, modified, deletedIds as number[])
      }
      columnDefs={configQuantoColumnDefs}
      newRowDefaults={newConfigQuantoDefaults}
    />
  );
}
